import i18next from 'i18next';
import {toast} from 'react-toastify';
import {NOTIFY_OPTS} from '../constants/Notifiers';

export const PDF_GENERATION_SLOW_DELAY_MS = 10000;

export const pdfBackgroundFailureReason = (status) => (
  status === 'failed' ? i18next.t('PDF_BACKGROUND_FAILED_REASON') : ''
);

export const beginPdfGenerationFeedback = () => {
  let settled = false;
  const toastId = toast(i18next.t('PDF_GENERATING'), NOTIFY_OPTS.defaultFromTop);
  const slowMessageTimer = setTimeout(() => {
    if(!settled){
      toast.update(toastId, {
        render:i18next.t('PDF_GENERATION_SLOW')
      });
    }
  }, PDF_GENERATION_SLOW_DELAY_MS);

  const settle = (callback) => {
    if(settled){
      return;
    }

    settled = true;
    clearTimeout(slowMessageTimer);
    callback();
  };

  return {
    complete:() => settle(() => toast.dismiss(toastId)),
    fail:() => settle(() => toast.update(toastId, {
      render:i18next.t('PDF_GENERATION_FAILED'),
      type:toast.TYPE.ERROR,
      autoClose:5000,
      closeOnClick:true
    }))
  };
};
